export default __webpack_public_path__ + "static/media/4.ff5429b2.jpg";